import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getSearchConfig, postSearchConfig } from '../../services/search';
import useLocalStorage from '../../hooks/useUserData';
import SearchSection from '../../components/fragments/SearchSection';
import { showNotification } from '../../utilities/mantineNotification';
import { Grid } from '@mantine/core';
import LoaderContentItem from '../../components/section/ContentSection/LoaderContentItem';

const SearchPage = (props) => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const [dataSearch, setDataSearch] = useState([]);
  const data = JSON.parse(userData?.auth);
  const location = useLocation();

  const queryParams: any = new URLSearchParams(location.search);

  const querysearch = queryParams.get('search');

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    return JSON.parse(object.auth).userData;
  };

  const _userData = getUserData();

  useEffect(() => {
    if (querysearch === '' || querysearch === null) {
      // go to home
      props.history.push('/home');
    } else {
    }
  }, [querysearch]);

  const [dataPayload, setDataPayload] = useState({
    BusinessUnitCode: _userData.businessUnitCode,
    type: '',
    isUmum: 'N',
    limit: 8,
    course: {
      search: querysearch?.toLowerCase()
    },
    content: {
      search: querysearch?.toLowerCase(),
      category: null
    },
    personalwisdom: {
      search: querysearch?.toLowerCase()
    },
    leaderwisdom: {
      search: querysearch?.toLowerCase()
    },
    fns: {
      search: querysearch?.toLowerCase()
    },
    testimony: {
      search: querysearch?.toLowerCase()
    }
  });

  useEffect(() => {
    const dataTemp = {
      BusinessUnitCode: _userData.businessUnitCode,
      type: '',
      isUmum: 'N',
      limit: 8,
      course: {
        search: querysearch?.toLowerCase()
      },
      content: {
        search: querysearch?.toLowerCase(),
        category: null
      },
      personalwisdom: {
        search: querysearch?.toLowerCase()
      },
      leaderwisdom: {
        search: querysearch?.toLowerCase()
      },
      fns: {
        search: querysearch?.toLowerCase()
      },
      testimony: {
        search: querysearch?.toLowerCase()
      }
    };
    setDataPayload(dataTemp);
  }, [querysearch]);

  useEffect(() => {
    fetchedSearchConfig.mutate(dataPayload);
  }, [dataPayload]);

  const fetchedSearchConfig = useMutation({
    mutationFn: postSearchConfig,
    onSuccess: () => {
      // console.log(data);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  // const fetchedSearchConfig = useQuery({
  //   queryKey: [`searchConfig-${querysearch}`],
  //   queryFn: () => postSearchConfig(dataPayload),
  //   enabled: !!querysearch
  // });

  return (
    <AdminLayout>
      <Breadcrumbs pageTitle={`Result for "${querysearch}"`} itemList={[]} />
      {fetchedSearchConfig.isLoading && (
        <Grid mb={10}>
          {[...Array(4)].map((_, index) => (
            <Grid.Col key={index} span={3}>
              <LoaderContentItem />
            </Grid.Col>
          ))}
        </Grid>
      )}
      <SearchSection
        querysearch={querysearch}
        pageSection={fetchedSearchConfig?.data?.data?.pageSection || []}
        loading={fetchedSearchConfig.isLoading}
        isError={fetchedSearchConfig.isError}
      />
    </AdminLayout>
  );
};

export default SearchPage;
